export enum RateScheduleType {   
    Fixed,
    TimeOfUse
}

export const RateScheduleTypeNames = new Map<number, string>([
    [RateScheduleType.Fixed, 'Fixed'],
    [RateScheduleType.TimeOfUse, 'Time of Use']  
]);